const isValidSku = (str) => /^\d+$/.test(str);

async function getProductInfo(sku) {
  try {
    
    const responseProduct = await fetch(`https://sfc2akxvwaaxslp7iknupzh5ua0itbyj.lambda-url.us-east-1.on.aws/api/products/${sku}`);
    const productData = await responseProduct.json();

    return productData;

  } catch(error) {
    console.error("Ha ocurrido un error al obtener los datos" + error.toString())
  }
}

function goToWhatsapp(sku) {  
  window.open(`https://wa.me/+5215519477295?text=Hola.%20Me%20gustar%C3%ADa%20saber%20el%20tiempo%20de%20entrega%20del%20producto%20con%20el%20sku%20${sku}`)
}


document.addEventListener("DOMContentLoaded", async () => {
  const containerWhatsapp = document.querySelector("#div-whatsapp");
  const sku = document.querySelector("span[data-product-sku]").innerText;
  
  if(!isValidSku){
    return 
  }
  
  const product = await getProductInfo(sku);
  
  if(product?.cantidad_disponible <= 0){
    containerWhatsapp.style.display = "flex";

    containerWhatsapp.addEventListener("click",() => goToWhatsapp(sku));
  }
});


document.addEventListener("DOMContentLoaded", () => {
  const tabLinks = document.querySelectorAll(".tab-link");
  const tabPanels = document.querySelectorAll(".tab-panel");

  const activateFirstTab = () => {
    const firstTab = Array.from(tabLinks).find(link => {
      const tabId = link.dataset.tab;
      const panel = document.getElementById(tabId);
      return panel && panel.innerHTML.trim() !== "";  
    });

    if (firstTab) {
      firstTab.classList.add("active");
      document.getElementById(firstTab.dataset.tab).classList.add("active");
    }
  };

  activateFirstTab();

  tabLinks.forEach(link => {
    link.addEventListener("click", () => {
      tabLinks.forEach(tab => tab.classList.remove("active"));
      tabPanels.forEach(panel => panel.classList.remove("active"));
      link.classList.add("active");
      document.getElementById(link.dataset.tab).classList.add("active");
    });
  });
});